(function () {
    "use strict";

    angular
        .module("app")
        .factory("QUtil", qUtil);

    qUtil.$inject = ["$q"];

    function qUtil($q) {
        return {
            whenAll: function (funcs) {
                var deferred = $q.defer();
                var resolvedCount = 0;

                var resolve = function () {
                    resolvedCount++;

                    if (resolvedCount >= funcs.length) {
                        deferred.resolve();
                    }
                };

                for (var fn in funcs) {
                    funcs[fn]().then(resolve, resolve);
                }

                if (!funcs || funcs.length === 0)
                    deferred.resolve();

                return deferred.promise;
            }
        };
    }
})();
